import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Quote from "./pages/Quote";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
  return null;
}

// Hook up scroll animations globally
function ScrollAnimator() {
  const { pathname } = useLocation(); // ← ADD THIS

  // Reset on route change
  useEffect(() => {
    document.querySelectorAll(".animate-on-scroll").forEach((el) => {
      el.classList.remove("visible");
    });
  }, [pathname]);

  // Re-observe on route change
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.12, rootMargin: "200px 0px 0px 0px" } // ← 200px so above-fold elements always trigger
    );

    const timer = setTimeout(() => {
      document.querySelectorAll(".animate-on-scroll").forEach((el) => {
        observer.observe(el);
      });
    }, 50);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [pathname]); // ← pathname here too

  return null;
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <ScrollAnimator />
      <div className="flex flex-col min-h-screen font-montserrat">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/quote" element={<Quote />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}
